import styled from '@emotion/styled';
import { Switch } from '@mui/material';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.div`
  border: 1px solid #eee;
  border-radius: 16px;
  height: 10rem;
  font-family: 'metropolis', sans-serif;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 0.375rem 1rem;
`;

export const CardTitle = styled.h4`
  margin-block: 0.5rem;
  font-weight: 500;
  font-size: 1rem;
  font-weight: bold;
`;

export const CardBody = styled.div`
  padding: 1rem;
  overflow: auto;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARKER};
  flex-grow: 1;
`;

export const StyledSwitch = styled(Switch)`
  & .MuiSwitch-switchBase.Mui-checked {
    color: ${colors.GREEN_LEAF};
  }

  & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
    background-color: ${colors.GREEN_LEAF};
  }
`;
